import { createContext } from 'react';

import type { AppConfig } from '@/utils';

export interface GlobalData {
  appConfig: AppConfig,
  // storeInfo: AppConfig
  [key: string]: any;
}

export default createContext<GlobalData>({ appConfig: {}, storeInfo: {} });
